import React, { FC } from 'react'

import { IconType } from '../../common/types'

const NucEyeClose: FC<IconType> = ({
  iconColor = 'currentColor',
  ...svgProps
}) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 28 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M6.69531 4.74609C8.62891 3.28516 11.0352 2.125 14 2.125C17.4375 2.125 20.2305 3.71484 22.25 5.60547C24.2695 7.45312 25.6016 9.6875 26.2461 11.2344C26.375 11.5781 26.375 11.9648 26.2461 12.3086C25.6875 13.6836 24.5273 15.6602 22.8086 17.3789L27.3203 20.9453C27.793 21.2891 27.8789 21.9336 27.4922 22.3633C27.1484 22.8359 26.5039 22.9219 26.0742 22.5352L0.636719 2.59766C0.164062 2.25391 0.078125 1.60938 0.464844 1.17969C0.808594 0.707031 1.45312 0.621094 1.88281 1.00781L6.69531 4.74609ZM9.83203 7.19531L13.6992 10.2461C13.8711 9.85938 14 9.47266 14 9C14 8.52734 13.8281 8.05469 13.6133 7.66797C13.7422 7.66797 13.8711 7.625 14 7.625C16.2773 7.625 18.125 9.47266 18.125 11.75C18.125 12.3516 17.9961 12.9102 17.7383 13.4258L19.4141 14.7148C19.8867 13.8555 20.1875 12.8242 20.1875 11.75C20.1875 8.35547 17.3945 5.5625 14 5.5625C12.3672 5.5625 10.9062 6.20703 9.83203 7.19531ZM14 21.375C10.5195 21.375 7.72656 19.8281 5.70703 17.9375C3.6875 16.0469 2.35547 13.8125 1.71094 12.3086C1.58203 11.9648 1.58203 11.5781 1.71094 11.2344C2.14062 10.2461 2.82812 9 3.81641 7.71094L7.85547 10.8906C7.8125 11.1914 7.8125 11.4922 7.8125 11.75C7.8125 15.1875 10.5625 17.9375 14 17.9375C14.7734 17.9375 15.5469 17.8086 16.2773 17.5078L19.4141 20C17.8242 20.8594 16.0195 21.375 14 21.375Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucEyeClose
